import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType, AdditionalInsurers } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class InsurersValidationService {
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {

  }
  addInsurersSubject: Subject<AdditionalInsurers> = new Subject<AdditionalInsurers>();
  addInsurers$ = this.addInsurersSubject.asObservable();
  removeInsurersSubject: Subject<PersonType> = new Subject<PersonType>();
  removeInsurers$ = this.removeInsurersSubject.asObservable();
  insurersValidSubject: Subject<Validation> = new Subject<Validation>();
  insurersValid$ = this.insurersValidSubject.asObservable();
  private error: Validation = new Validation();
  isInValid(contractType: ContractType): boolean {
    let validation = this.insurersValidation(contractType)
    return validation.isInValid;
  }
  private insurersValidation(contractType: ContractType): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    for (let i = 1; i < contractType.policyHolder.length; i++) {
      if (contractType.policyHolder[i].birthDate == null || contractType.policyHolder[i].birthDate == undefined || contractType.policyHolder[i].birthDate == "Invalid Date") {
        validation.isInValid = true;
        validation.errorCss = CssClass.error;
        validation.errorMessage = ErrorMessage.providePrimaryDOB
        validation.index = i - 1;
        this.gtmDataLayerUiService.setCjError(ErrorMessage.providePrimaryDOB)
        this.setError(validation);
      }
      else if (contractType.policyHolder[i].birthDate == ErrorMessage.insurerInvalidAge) {
        validation.isInValid = true;
        validation.errorCss = CssClass.error;
        validation.errorMessage = ErrorMessage.insurerInvalidAge;
        validation.index = i - 1;
        this.gtmDataLayerUiService.setCjError(ErrorMessage.insurerInvalidAge)
        this.setError(validation);
      }
      else if (contractType.policyHolder[i].birthDate == ErrorMessage.futureDate) {
        validation.isInValid = true;
        validation.errorCss = CssClass.error;
        validation.errorMessage = ErrorMessage.futureDate;
        validation.index = i - 1;
        this.gtmDataLayerUiService.setCjError(ErrorMessage.futureDate)
        this.setError(validation);
      }
      else {
        let removeError: Validation = new Validation();
        removeError.isInValid = false
        removeError.errorCss = '';
        removeError.index = i - 1;
        this.setError(removeError)
      }
    }
   
    return validation;
  }
  setError(error: Validation) {
    this.insurersValidSubject.next(error);
  }

  addInsurer() {
    let insurer = new AdditionalInsurers();
    this.addInsurersSubject.next(insurer);
  }
  addSwInsurer(insurer: AdditionalInsurers) {
    this.addInsurersSubject.next(insurer);
  }
  removeInsurer() {
    this.removeInsurersSubject.next(null);
  }
}
